export default __webpack_public_path__ + "static/media/respinos-general-instruction.f90bdf0d.pdf";